export const ClientStatusList = ["active", "inactive"] as const;

export const ClientThingTypeMrn = "mrn:sl2:::client";
